import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import {
  changeTrip,
  addAdult,
  minusAdult,
  addChildren,
  minusChildren,
  pickDate,
  addToCart,
  removeFromCart
} from "./Store/Actions/EuropeActions";
import {
  asiaChangeTrip,
  asiaAddAdult,
  asiaMinusAdult,
  asiaAddChildren,
  asiaMinusChildren,
  asiaPickDate,
  asiaAddToCart,
  asiaRemoveFromCart
} from "./Store/Actions/AsiaActions";
import {
  americaChangeTrip,
  americaAddAdult,
  americaMinusAdult,
  americaAddChildren,
  americaMinusChildren,
  americaPickDate,
  americaAddToCart,
  americaRemoveFromCart
} from "./Store/Actions/AmericaActions";
import ImgDiv from "./ItemDetails/ImgDiv";
import Description from "./ItemDetails/Description";
import FeaturedItemsItemDetails from "./ItemDetails/FeaturedItemsItemDetails";

class ItemInfo extends Component {
  constructor() {
    super();
    this.state = {
      random: Math.floor(Math.random() * 5)
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    // Define correct item
    const EuropeData = this.props.europeData
      .map(item => (this.props.location.pathname === item.link ? item : "fail"))
      .filter(checkNull);
    const AsiaData = this.props.asiaData
      .map(item => (this.props.location.pathname === item.link ? item : "fail"))
      .filter(checkNull);
    const AmericaData = this.props.americaData
      .map(item => (this.props.location.pathname === item.link ? item : "fail"))
      .filter(checkNull);
    const [itemInfo] = EuropeData.concat(AsiaData, AmericaData);

    // Define wchich item is used
    const otherItemsEurope = this.props.europeData
      .map(item => (this.props.location.pathname !== item.link ? item : "fail"))
      .filter(checkNull);
    const otherItemsAsia = this.props.asiaData
      .map(item => (this.props.location.pathname !== item.link ? item : "fail"))
      .filter(checkNull);
    const otherItemsAmerica = this.props.americaData
      .map(item => (this.props.location.pathname !== item.link ? item : "fail"))
      .filter(checkNull);

    // function for chacking "fail"
    function checkNull(arr) {
      return arr !== "fail";
    }

    // define continent
    let continent;

    if (
      this.props.location.pathname === "/europe/venice" ||
      this.props.location.pathname === "/europe/rome" ||
      this.props.location.pathname === "/europe/warsaw" ||
      this.props.location.pathname === "/europe/paris" ||
      this.props.location.pathname === "/europe/moscow" ||
      this.props.location.pathname === "/europe/london"
    ) {
      continent = "Europe";
    } else if ( this.props.location.pathname === "/asia/shanghai" ||
    this.props.location.pathname === "/asia/kuala-lumpur" ||
    this.props.location.pathname === "/asia/tokio" ||
    this.props.location.pathname === "/asia/sigapore" ||
    this.props.location.pathname === "/asia/bali" ||
    this.props.location.pathname === "/asia/bangkok") {
      continent = "Asia";
    } else {continent = 'America'}

    // define correct changeTrip function
    let changeTripFunction;

    if (continent === "Europe") {
      changeTripFunction = this.props.changeTrip;
    } else if (continent === "Asia"){
      changeTripFunction = this.props.asiaChangeTrip;
    } else {
      changeTripFunction = this.props.americaChangeTrip;
    }

    // define correct addAdult function
    let addAdultFunction;

    if (continent === "Europe") {
      addAdultFunction = this.props.addAdult;
    } else if (continent === "Asia") {
      addAdultFunction = this.props.asiaAddAdult;
    } else {
      addAdultFunction = this.props.americaAddAdult;
    }

    // define correct minusAdult function
    let minusAdultFunction;

    if (continent === "Europe") {
      minusAdultFunction = this.props.minusAdult;
    } else if (continent === "Asia") {
      minusAdultFunction = this.props.asiaMinusAdult;
    } else {
      minusAdultFunction = this.props.americaMinusAdult;
    }

    // define correct addChildren function
    let addChildrenFunction;

    if (continent === "Europe") {
      addChildrenFunction = this.props.addChildren;
    } else if (continent === "Asia") {
      addChildrenFunction = this.props.asiaAddChildren;
    } else {
      addChildrenFunction = this.props.americaAddChildren;
    }

    // define correct minusChildren function
    let minusChildrenFunction;

    if (continent === "Europe") {
      minusChildrenFunction = this.props.minusChildren;
    } else if (continent === "Asia") {
      minusChildrenFunction = this.props.asiaMinusChildren;
    } else {
      minusChildrenFunction = this.props.americaMinusChildren;
    }

    // define correct pickDate function 
    let pickDateFunction;

    if (continent === "Europe") {
      pickDateFunction = this.props.pickDate;
    } else if (continent === "Asia") {
      pickDateFunction = this.props.asiaPickDate;
    } else {
      pickDateFunction = this.props.americaPickDate;
    }

    // define correct addToCart function
    let addToCartFunction;

    if (continent === "Europe") {
      addToCartFunction = this.props.addToCart;
    } else if (continent === "Asia") {
      addToCartFunction = this.props.asiaAddToCart;
    } else {
      addToCartFunction = this.props.americaAddToCart;
    }

    // define correct removeFromCart function
    let removeFromCartFunction;

    if (continent === "Europe") {
      removeFromCartFunction = this.props.removeFromCart;
    } else if (continent === "Asia") {
      removeFromCartFunction = this.props.asiaRemoveFromCart;
    } else {
      removeFromCartFunction = this.props.americaRemoveFromCart;
    }

    // define trip option and price
    let tripOption1;
    let tripOption2;
    let tripOption3;
    let price1;
    let price2;

    if (itemInfo.choosenTrip === "day") {
      tripOption1 = itemInfo.dailyTripDate1;
      tripOption2 = itemInfo.dailyTripDate2;
      tripOption3 = itemInfo.dailyTripDate3;
      price1 = itemInfo.dailyPriceAdult;
      price2 = itemInfo.dailyPriceChildren;
    } else if (itemInfo.choosenTrip === "week") {
      tripOption1 = itemInfo.weekTripDate1;
      tripOption2 = itemInfo.weekTripDate2;
      tripOption3 = itemInfo.weekTripDate3;
      price1 = itemInfo.weekPriceAdult;
      price2 = itemInfo.weekPriceChildren;
    } else {
      tripOption1 = itemInfo.monthTripDate1;
      tripOption2 = itemInfo.monthTripDate2;
      tripOption3 = itemInfo.monthTripDate3;
      price1 = itemInfo.monthPriceAdult;
      price2 = itemInfo.monthPriceChildren;
    }

    return (
      <div className="container pt-3">
        {console.log(this.props.europeData, this.props.asiaData, this.props.americaData)}
        <div className="row">
          <ImgDiv img={itemInfo.img} title={itemInfo.title} />

          <div className="col-12 col-md-3 card">
            <div className="mt-4">
              <h3>{itemInfo.title} trip</h3>
              <h6 className="">Lowest price guaranteed</h6>
            </div>
            <hr />
            <h5>Pick a trip and add travelers</h5>
            <form className="d-flex flex-column">
              <select
                name="tripSelector"
                value={itemInfo.choosenTrip}
                onChange={e => changeTripFunction(itemInfo.id, e)}
                className="mt-3"
              >
                <option value="" disabled>
                  Choose an option
                </option>
                <option value="day" disabled={itemInfo.dailyTrip ? null : true}>
                  Daily trip {itemInfo.dailyTrip ? null : "- Unavaiable"}
                </option>
                <option value="week" disabled={itemInfo.weekTrip ? null : true}>
                  Weekly trip {itemInfo.weekTrip ? null : "- Unavaiable"}
                </option>
                <option
                  value="month"
                  disabled={itemInfo.monthTrip ? null : true}
                >
                  Monthly trip {itemInfo.monthTrip ? null : "- Unavaiable"}
                </option>
              </select>
              <div
                className={classNames(
                  "mt-2 hidden small",
                  itemInfo.choosenTrip !== "" ? "show d-flex" : ""
                )}
              >
                <p className="my-0 align-self-center">Price:</p>
                <div className="ml-3 d-flex">
                  <p className="my-0 mr-2">Adults: ${price1}</p>
                  <p className="my-0">Childrens: ${price2}</p>
                </div>
              </div>
              <select
                className={classNames(
                  "hidden mt-3",
                  itemInfo.choosenTrip !== "" ? "show" : ""
                )}
                name="dateSelector"
                value={itemInfo.dateOption}
                onChange={e => pickDateFunction(itemInfo.id, e)}
              >
                <option value="" disabled>
                  Pick a date
                </option>
                <option value="date1">{tripOption1}</option>
                <option value="date2">{tripOption2}</option>
                <option value="date3">{tripOption3}</option>
              </select>

              <div className="mt-3">
                <button
                  className="btn btn-info w-100"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  {itemInfo.totalTravelers <= 0
                    ? "Numbers of travelers"
                    : (itemInfo.adultCount <= 0
                        ? ""
                        : itemInfo.adultCount +
                          " Adult" +
                          (itemInfo.adultCount > 1 ? "s" : "")) +
                      " " +
                      (itemInfo.childrenCount <= 0
                        ? ""
                        : itemInfo.childrenCount +
                          " Children" +
                          (itemInfo.childrenCount > 1 ? "s" : ""))}
                </button>{" "}
                <div className="collapse" id="collapseExample">
                  <p className="travelers-min-max">
                    {" "}
                    You can select up to 9 travelers in total
                  </p>
                  <div className="d-flex">
                    <div className="">
                      <p className="my-0 travelers-name">Adults (age: 13-99)</p>
                      <p className="my-0 travelers-min-max">
                        Minimum: 1 Maximum: 9
                      </p>
                    </div>
                    <div className="d-flex align-items-center ml-auto">
                      <button
                        className="fas fa-plus-circle travel-adjust mx-2 p-0"
                        onClick={e => addAdultFunction(itemInfo.id, e)}
                        disabled={itemInfo.totalTravelers === 9 ? true : false}
                      />
                      {itemInfo.adultCount}
                      <button
                        className="fas fa-minus-circle travel-adjust mx-2 p-0"
                        onClick={e => minusAdultFunction(itemInfo.id, e)}
                        disabled={itemInfo.adultCount > 1 ? false : true}
                      />
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="">
                      <p className="my-0 travelers-name">
                        Childrens (age: 1-12)
                      </p>
                      <p className="my-0 travelers-min-max">Maximum: 8</p>
                    </div>
                    <div className="d-flex align-items-center ml-auto">
                      <button
                        className="fas fa-plus-circle travel-adjust mx-2 p-0"
                        onClick={e => addChildrenFunction(itemInfo.id, e)}
                        disabled={itemInfo.totalTravelers === 9 ? true : false}
                      />
                      {itemInfo.childrenCount}
                      <button
                        className="fas fa-minus-circle travel-adjust mx-2 p-0"
                        onClick={e => minusChildrenFunction(itemInfo.id, e)}
                        disabled={itemInfo.childrenCount > 0 ? false : true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex mt-3">
                <p className="mr-2">Total:</p>
                <p>${itemInfo.total}</p>
              </div>

              {itemInfo.inCart ? (
                <button
                  onClick={e => removeFromCartFunction(itemInfo.id, e)}
                  className="btn btn-danger mb-2"
                >
                  Remove from cart
                </button>
              ) : (
                <button
                  onClick={e => addToCartFunction(itemInfo.id, e)}
                  disabled={
                    itemInfo.totalTravelers === 0 || itemInfo.choosenDate === ""
                      ? true
                      : false
                  }
                  className="btn btn-success mb-2"
                >
                  Add to cart
                </button>
              )}
            </form>
          </div>
          <Description
            description={itemInfo.description}
            description2={itemInfo.description2}
            description3={itemInfo.description3}
          />
          <div className="col-12 col-md-3 pt-3">
            <h6 className="text-center w-100"> Featured items</h6>
            <FeaturedItemsItemDetails
              img={otherItemsEurope[this.state.random].img}
              title={otherItemsEurope[this.state.random].title}
              link={otherItemsEurope[this.state.random].link}
            />
            <FeaturedItemsItemDetails
              img={otherItemsAsia[this.state.random].img}
              title={otherItemsAsia[this.state.random].title}
              link={otherItemsAsia[this.state.random].link}
            />
            <FeaturedItemsItemDetails
              img={otherItemsAmerica[this.state.random].img}
              title={otherItemsAmerica[this.state.random].title}
              link={otherItemsAmerica[this.state.random].link}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  europeData: state.europe,
  asiaData: state.asia,
  americaData: state.america
});

const mapDispatchToProps = dispatch => {
  return {
    changeTrip: (id, data) => {
      dispatch(changeTrip(id, data));
    },
    addAdult: (id, data) => {
      dispatch(addAdult(id, data));
    },
    minusAdult: (id, data) => {
      dispatch(minusAdult(id, data));
    },
    addChildren: (id, data) => {
      dispatch(addChildren(id, data));
    },
    minusChildren: (id, data) => {
      dispatch(minusChildren(id, data));
    },
    pickDate: (id, data) => {
      dispatch(pickDate(id, data));
    },
    addToCart: (id, data) => {
      dispatch(addToCart(id, data));
    },
    removeFromCart: (id, data) => {
      dispatch(removeFromCart(id, data));
    },
    asiaChangeTrip: (id, data) => {
      dispatch(asiaChangeTrip(id, data));
    },
    asiaAddAdult: (id, data) => {
      dispatch(asiaAddAdult(id, data));
    },
    asiaMinusAdult: (id, data) => {
      dispatch(asiaMinusAdult(id, data));
    },
    asiaAddChildren: (id, data) => {
      dispatch(asiaAddChildren(id, data));
    },
    asiaMinusChildren: (id, data) => {
      dispatch(asiaMinusChildren(id, data));
    },
    asiaPickDate: (id, data) => {
      dispatch(asiaPickDate(id, data));
    },
    asiaAddToCart: (id, data) => {
      dispatch(asiaAddToCart(id, data));
    },
    asiaRemoveFromCart: (id, data) => {
      dispatch(asiaRemoveFromCart(id, data));
    },
    americaChangeTrip: (id, data) => {
      dispatch(americaChangeTrip(id, data));
    },
    americaAddAdult: (id, data) => {
      dispatch(americaAddAdult(id, data));
    },
    americaMinusAdult: (id, data) => {
      dispatch(americaMinusAdult(id, data));
    },
    americaAddChildren: (id, data) => {
      dispatch(americaAddChildren(id, data));
    },
    americaMinusChildren: (id, data) => {
      dispatch(americaMinusChildren(id, data));
    },
    americaPickDate: (id, data) => {
      dispatch(americaPickDate(id, data));
    },
    americaAddToCart: (id, data) => {
      dispatch(americaAddToCart(id, data));
    },
    americaRemoveFromCart: (id, data) => {
      dispatch(americaRemoveFromCart(id, data));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemInfo);
